import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=6da2f86e&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"
import style0 from "./Table.vue?vue&type=style&index=0&id=6da2f86e&prod&lang=scss&scoped=true"
import style1 from "./Table.vue?vue&type=style&index=1&id=6da2f86e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da2f86e",
  null
  
)

export default component.exports